<template>
  <!-- 首页 -->
  <el-container :style="{ height: container.height }">
    <el-aside width="200px" style="background-color: #344158">
      <el-menu router background-color="#344158" @select="handleSelect" text-color="#fff" active-text-color="#ffd04b" style="width: 100%; border: 0; padding-top: 20px" :default-active="defaultActive">
        <el-menu-item index="/admin/homePage">
          <template slot="title">
            <i class="el-icon-monitor" style="color: #fff"></i>
            <span>网站首页</span>
          </template>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-files" style="color: #fff; padding-bottom: 3px"></i>
            <span>业务范围</span>
          </template>
          <el-menu-item index="/admin/scopeInfo">标题内容</el-menu-item>
          <el-menu-item index="/admin/scopeDetail">范围内容</el-menu-item>
        </el-submenu>

        <el-menu-item index="/admin/serviceInfo">
          <template slot="title">
            <i class="el-icon-reading" style="color: #fff"></i>
            <span>服务内容</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/cartList">
          <template slot="title">
            <i class="el-icon-picture-outline" style="color: #fff"></i>
            <span>合作伙伴</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container style="background-color: #eee">
      <el-header style="height: 40px; background-color: #fff">
        <el-breadcrumb separator="/" style="line-height: 40px; margin-left: 15px">
          <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
            <router-link v-if="item.url" :to="item.url">{{item.name}}</router-link>
            <a v-else>{{ item.name }}</a>
          </el-breadcrumb-item>
          <div style="float:right;margin-right:20px">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="el-dropdown-link">
                <span style="margin-left:12px">角色:{{ roleName }}</span>
                <span style="margin-left:12px">{{ userName }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">修改密码</el-dropdown-item>
                <el-dropdown-item command="2">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-breadcrumb>
      </el-header>
      <el-main :style="{padding: '0px',margin: '0px',overflow: 'auto',height: mainStyle.height,margin:'10px 10px'}">
        <router-view />
      </el-main>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="800px" :close-on-click-modal="false">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="addParams.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="addParams.confirmPassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      defaultActive:sessionStorage.getItem("defaultActive"),
      userName: localStorage.getItem("userName"),
      roleName: localStorage.getItem("roleName"),
      roleId:localStorage.getItem("roleId"),
      mainStyle: { height: "0px" },
      container: { height: "0px" },
      addParams:{
        password:"",
        confirmPassword:""
      },
      rules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' }
        ]
      },
      dialogFormVisible:false
    };
  },
  mounted() {
    console.log(sessionStorage.getItem("defaultActive"))
    this.initHeight();
    window.onresize = () => {
      return (() => {
        this.initHeight();
      })();
    };
  },
  methods: {
    initHeight() {
      //el-main高度自适应
      this.windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight; //浏览器高度
      this.mainStyle.height = this.windowHeight - 40 + "px";
      this.container.height = this.windowHeight + "px";
    },
    handleCommand(command) {
      if(command === "1"){
        this.dialogFormVisible = true
      }
      if (command === "2") {
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        this.$router.push("/admin");
      } else {
        this.dialogFormVisible = true;
      }
    },
    handleSelect(index){
      sessionStorage.setItem("defaultActive",index)
    },
    editSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        } else {
          if(this.addParams.password != this.addParams.confirmPassword){
            this.$message.error("两次密码输入不一致");
            return
          }
          this.addParams.id = localStorage.getItem("userId");
          this.axios({
            method: "post",
            url: "/y-user-info/update",
            data: this.addParams,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormVisible = false;
              this.$message({message: "修改成功", type: "success"});
              localStorage.removeItem("userName");
              localStorage.removeItem("roleId");
              localStorage.removeItem("userId");
              localStorage.setItem("defaultActive", "/admin")
              this.$router.push("/admin");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    }
  },
};
</script>

<style>
.el-submenu__title {
  padding-left: 40px !important;
}
.el-menu-item {
  padding-left: 40px !important;
}
.el-submenu .el-menu-item {
  padding-left: 60px !important;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  border: 2px solid #919191;
  border-radius: 10px;
  display: block;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
